module.exports = __webpack_public_path__ + "img/coupon.25afce91.png";